



















































































import { Component, Vue } from 'vue-property-decorator';
import { SysModule } from '@/store/modules/sys'
import { AppModule } from '@/store/modules/app';
import AppDto from '@/models/Apps/AppDto'
import IconConstants from '@/lib/iconConstants';
import GiganautVue from '@/components/Shared/GiganautVue';
import AppEdit from '@/components/Apps/AppEdit.vue';
import GiganautAppIcon from '@/components/Apps/Display/GiganautAppIcon.vue';

@Component({
  name: 'SysApps',
  components: { AppEdit, GiganautAppIcon }
})
export default class extends GiganautVue {
    
    public currentIndex = 0;

    async updateCurrentApp(app: AppDto) {
        SysModule.updateCurrentApp(app);
    }

    get currentApp() {
        return SysModule.currentApp;
    }

    get apps() {
        return SysModule.apps;
    }
}
